import { CustomerTypes } from "@utils/enums";

import { CustomerModel } from "./@types/customer.model";

export const $CustomerModuleName = "customer";

export type TCustomerState = CustomerModel;

export type SubscriptionRequest = {
    email: string;
    firstName?: string;
    lastName?: string;
    storeId: string;
};

export type UpdateCustomerRequest = {
    customerType: CustomerTypes;
    firstName: string;
    lastName: string;
    companyName?: string | null;
    vatNr?: string | null;
    phone?: string | null;
    dateOfBirth?: string | null;
    favouriteStoreId?: string | null;
    receiveSms: boolean;
    language: string;
    bonusCardNumber?: string | null;
    requestInvoice: boolean;
    newsLetterSubscribed: boolean;
};
